export const localFeatureIds = [
  //
  'export video',
  'ss onboarding',
  'smartlook-canvas',
  'professional-trial-14-days',
  'onboarding-pro-schedule',
  'sourcing-assistant',
  'design-assistant',
  'signup-check-email-flow',
  'signup-google-button',
  'signup-tracking-page',
  'template-assistant-no-chat',
  'price-alert',
  'viz-magic-render',
  'viz-magic-bg-removal-hd',
  'slazzer',
  'onboarding-things',
  'viz-magic-edit-background',
  'viz-magic-edit-object',
  'viz-magic-create-background',
  'viz-magic-create-object',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'viz-object-panels',
] as const

export const externalFeatureIds = [
  //
  'smartlook-canvas',
  'professional-trial-14-days',
  'onboarding-pro-schedule',
  'sourcing-assistant',
  'design-assistant',
  'signup-check-email-flow',
  'signup-google-button',
  'signup-tracking-page',
  'template-assistant-no-chat',
  'price-alert',
  'viz-magic-render',
  'viz-magic-bg-removal-hd',
  'slazzer',
  'onboarding-things',
  'viz-magic-edit-background',
  'viz-magic-edit-object',
  'viz-magic-create-background',
  'viz-magic-create-object',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'viz-object-panels',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
